/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserClaimsDto = {
    readonly id?: string;
    readonly username?: string;
    readonly givenName?: string;
    readonly familyName?: string;
    readonly email?: string;
    readonly companyName?: string;
    readonly companyId?: string;
    readonly companyRegistrationState?: UserClaimsDto.companyRegistrationState;
};
export namespace UserClaimsDto {
    export enum companyRegistrationState {
        PENDING = 'PENDING',
        IN_APPROVAL = 'IN_APPROVAL',
        IN_PROGRESS = 'IN_PROGRESS',
        CHECK_COMPANY_DATA = 'CHECK_COMPANY_DATA',
        CREATE_INVOICE = 'CREATE_INVOICE',
        UPLOAD_INVOICE = 'UPLOAD_INVOICE',
        ACTIVATE = 'ACTIVATE',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }
}

